export class ProjectSurvey {
    surveyId: number;
    engagementId: number;
    surveyName: string;
    statusId: number;
    state: string;
    status: string;
    userName: string;
    userId: string;
    displayName: string;
    displayNameCount: number;
    displayNameOutput: string;
    displayNameList: string[];
    countOfSurveyDocument: number;
    reminderFrequency: number;
    numberOfComments: number;
    dueDate: Date;
    nextEmailDate: Date;
    completedOn: Date;
    costCenter: string;
    companyName: string;
    sourceFile: string;
    followUp: Date;
    lastUpdate: Date;
    updatedBy: string;
    submitBy: string;
    // UI only properties
    isSelected: boolean;
    daysUntilDue: number;
    dueSoon: boolean;
    clientId: number;
    SMEUser: boolean = false;
    communicationStatus: number;
    reconciliation:number;
    lastEmailSentDate: Date;
    lastEmailSentStatus:string;
}

